export const CompetitionStatusConstants = {
    APPROVED: '7066C4D9-9F5F-471C-A713-013B61EA34E1'.toLocaleLowerCase(),
    DECLINED: '84D5A631-C5C1-41EF-AFC9-015152101634'.toLocaleLowerCase(),
    THREE_D_REDIRECT: '074AA97E-4BE8-427B-B163-364B65E1F7CF'.toLocaleLowerCase(),
    PENDING: '45344F39-3023-466C-9744-A102DD1914C5'.toLocaleLowerCase(),
};
